import Button from 'components/button/Button';
import { Navigate, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import HeroImage from 'assets/images/screenAndProtect/hero.png';
import CallToActionImage from 'assets/images/screenAndProtect/call-to-action.png';
import ChecklistPointIcon from 'assets/images/screenAndProtect/icons/checklist-point.svg?react';
import { useScreenAndProtectContext } from '../ScreenAndProtect';
import { GetProtectionButtonStyled } from '../common/ScreenAndProtectCommon.styles';
import LandingBenefitsCards from './LandingBenefitsCards';
import LandingProtectionItems from './LandingProtectionItems';
import {
  Container,
  HeroSection,
  BenefitsSection,
  ProtectionSection,
  CallToActionSection,
  SectionTitle,
  SectionSubtitle,
  BenefitsSectionBackground,
  ChecklistPoints,
} from './ScreenAndProtectLanding.styles';

const ScreenAndProtectLanding = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { isEnrolled } = useScreenAndProtectContext();

  if (isEnrolled) {
    return <Navigate to="/screen-and-protect/current" replace />;
  }

  const handleGetProtection = () => {
    navigate('/screen-and-protect/details');
  };

  return (
    <>
      <Container className="container" data-testid="screen-and-protect-landing">
        <HeroSection>
          <div>
            <h1>{t('pageScreenAndProtect.landingPage.hero.title')}</h1>
            <p>{t('pageScreenAndProtect.landingPage.hero.subtitle')}</p>
            <Button bsStyle="primary" onClick={handleGetProtection}>
              {t('pageScreenAndProtect.landingPage.getProtection')}
            </Button>
          </div>
          <div>
            <img src={HeroImage} alt="Hero" />
          </div>
        </HeroSection>
      </Container>

      <BenefitsSectionBackground>
        <Container className="container">
          <BenefitsSection>
            <SectionTitle color="blue">
              {t('pageScreenAndProtect.landingPage.benefits.title')}
            </SectionTitle>
            <SectionSubtitle>
              {t('pageScreenAndProtect.landingPage.benefits.subtitle')}
            </SectionSubtitle>
            <LandingBenefitsCards />
          </BenefitsSection>
        </Container>
      </BenefitsSectionBackground>

      <Container className="container">
        <ProtectionSection>
          <SectionTitle color="green">
            {t('pageScreenAndProtect.landingPage.protection.title')}
          </SectionTitle>
          <SectionSubtitle>
            {t('pageScreenAndProtect.landingPage.protection.subtitle')}
          </SectionSubtitle>
          <LandingProtectionItems />
        </ProtectionSection>

        <CallToActionSection>
          <div>
            <SectionTitle color="blue">
              {t('pageScreenAndProtect.landingPage.callToAction.title')}
            </SectionTitle>
            <SectionSubtitle>
              {t('pageScreenAndProtect.landingPage.callToAction.subtitle')}
            </SectionSubtitle>
            <div>
              <ChecklistPoints>
                <ul>
                  <li>
                    <ChecklistPointIcon />
                    {t(
                      'pageScreenAndProtect.landingPage.callToAction.saveTime',
                    )}
                  </li>
                  <li>
                    <ChecklistPointIcon />
                    {t(
                      'pageScreenAndProtect.landingPage.callToAction.avoidNegativeReviews',
                    )}
                  </li>
                  <li>
                    <ChecklistPointIcon />
                    {t(
                      'pageScreenAndProtect.landingPage.callToAction.safeguard',
                    )}
                  </li>
                  <li>
                    <ChecklistPointIcon />
                    {t(
                      'pageScreenAndProtect.landingPage.callToAction.receivePayments',
                    )}
                  </li>
                </ul>
              </ChecklistPoints>
              <img src={CallToActionImage} alt="Call to Action" />
            </div>

            <GetProtectionButtonStyled
              $colorScheme="green"
              onClick={handleGetProtection}
              data-testid="screen-and-protect-landing-get-protection-button"
            >
              {t('pageScreenAndProtect.landingPage.getProtection')}
            </GetProtectionButtonStyled>
          </div>
        </CallToActionSection>
      </Container>
    </>
  );
};

export default ScreenAndProtectLanding;
